module.exports = __webpack_public_path__ + "static/img/flowers.589850c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/flowers.png
// module id = 68Vf
// module chunks = 0